/**
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Snackbar entity component
  Date: April 2020
**/

import React from 'react';

import { useStoreState, useStoreActions } from 'easy-peasy';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const SubmitSnackbar = (props) => {
  const commonAction = useStoreActions((actions) => actions.common);
  const commonState = useStoreState((state) => state.common);

  const handleClose = (event, reason) => {
    commonAction.setSubmitSnackbar({
      status: false,
      messages: '',
      error: commonState.submitSnackbar.error,
    });
  };

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={commonState.submitSnackbar.status}
        autoHideDuration={commonState.submitSnackbar.timeout}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={commonState.submitSnackbar.error ? 'error' : 'success'}
        >
          {commonState.submitSnackbar.messages}
        </Alert>
      </Snackbar>
    </>
  );
};

export default SubmitSnackbar;
